const c = {
  "cdr-card": "cdr-card_13-5-3"
};
export {
  c as default
};
